import React from "react";
import "./../../styles/pages/CustomPage.css";
import anatomiaImage from "../../assets/cuidados/anatomia_mama.png"; // Imagen de anatomía de la mama

const CuidadosPage = () => {
  return (
    <div className="msf-container">
      {/* Introducción */}
      <div className="msf-row reverse">
        <div className="msf-text">
          <h2 className="custom-page-h2">Cómo cuidarte</h2>
          <div className="red-line"></div>
          <p>
            El cáncer de mama es un problema de Salud Pública de primer orden, por su magnitud,
            tumor maligno más frecuente en la mujer y por su incidencia, según la OMS cada 30
            segundos se diagnostica un caso en algún lugar del mundo. De ahí la importancia de estos
            foros de información y formación.
          </p>
          <p>
            Todos en general debemos concienciarnos de la importancia que tiene que nos
            involucremos en nuestra propia salud, más aún la mujer si es del cáncer de mama el tema
            que nos ocupa, pero ojo¡ que los varones no bajen la guardia, porque aunque con
            bastante menos proporción, también pueden padecerlo. Al nacer, el esbozo mamario es
            igual en ambos sexos y será la influencia hormonal, estrógenos en la mujer y andrógenos
            en el varón, la que module el desarrollo de las glándulas mamarias.
          </p>
        </div>
        <div className="msf-image">
          <img src={anatomiaImage} alt="Anatomía de la mama" className="anatomia-img" />
          <p>
            La mama tiene una forma anatómica de media esfera
            apoyada sobre el músculo pectoral con una
            vascularización específica y con un drenaje linfático
            característico que desde la areola y el pezón, se dirige
            mayoritariamente hacia la axila.
          </p>
        </div>
      </div>

      <div className="msf-row">
        <div className="msf-text">
          <p>
            Esa media esfera está compuesta de diferentes tejidos, grasa, glándulas, conductos...
            sometidos a muy diferentes estímulos a lo largo de toda nuestra vida. Antes y después de
            la menstruación, antes, durante y después de la gestación y el parto. Si somos jóvenes o
            no tan jóvenes. Todo ello y los factores externos, el ecosistema en el que vivimos con su
            grado de contaminación, la convierte en diana de diferentes enfermedades benignas y de
            la más seria e importante, el cáncer de mama.
          </p>
          <p>
            Conocer, aunque sea a grandes rasgos, como está compuesta y estructurada la mama,
            es una información valiosa tanto para planificar la autoexploración mamaria, como para
            realizar ejercicios con los brazos que nos ayudan a prevenir la aparición de linfedema
            después de la cirugía.
          </p>
        </div>
      </div>

      {/* Primer apartado: Autoexploración mamaria */}
      <div className="msf-row msf-row-image-first">
        <div className="msf-text">
          <h2 className="custom-page-h2">Autoexploración mamaria</h2>
          <div className="red-line"></div>
          <p>
            La autoexploración mamaria es un procedimiento sencillo que consiste en la revisión 
            periódica de las mamas por la propia persona para detectar posibles cambios o anomalías. 
            A continuación, compartimos un video instructivo que muestra la técnica correcta para 
            realizar esta exploración de forma efectiva.
          </p>
          
          <div className="page-video-container">
            <iframe 
              width="560" 
              height="315" 
              src="https://www.youtube.com/embed/Vwf2OcObFS0" 
              title="Video sobre autoexploración mamaria" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen>
            </iframe>
          </div>
        </div>
      </div>

      {/* Segundo apartado: Ejercicios para prevenir linfedema */}
      <div className="msf-row reverse">
        <div className="msf-text">
          <h2 className="custom-page-h2">Recomendaciones para prevenir la aparición del linfedema</h2>
          <div className="red-line"></div>
          <p>
            El linfedema es una acumulación anormal de líquido que causa inflamación, generalmente en los brazos, 
            y puede aparecer después de la cirugía de cáncer de mama cuando se extirpan ganglios linfáticos axilares. 
            Puede presentarse meses o incluso años después de la cirugía, por lo que las personas operadas deben 
            prestar especial atención al brazo del lado de la axila intervenida.
          </p>
          <p>
            Durante actividades como el senderismo, factores como el calor, el ejercicio intenso y llevar ropa 
            ajustada pueden aumentar el riesgo. Por ello, hemos preparado un documento con recomendaciones específicas 
            que puedes descargar a continuación.
          </p>
          <div className="pdf-download-container">
            <h3>Descarga nuestras recomendaciones completas</h3>
            <p>
              Este documento incluye consejos para el cuidado del brazo durante las jornadas de senderismo, 
              técnicas de drenaje linfático simple y ejercicios básicos para favorecer el flujo linfático.
            </p>
            <a href="/docs/recomendaciones-brazo.pdf" download className="pdf-download-button">
              <span className="download-icon">↓</span> Descargar recomendaciones (PDF)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CuidadosPage; 